<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const definitionPath = field<string>("definitionPath", "");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:link-2" accent="content">
    <EditorField :label="t('resourcePathLabel')" :hint="t('resourcePathHint')">
      <EditorPathInput
        v-model="definitionPath"
        mode="existing-file"
        :scopes="['site']"
        placeholder="../shared/header"
        aria-label="Included resource path"
      />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Included Resource"
  resourcePathLabel: "Resource path"
  resourcePathHint: "Select a resource definition or keep a legacy relative path."
</i18n>
